module.exports = __webpack_public_path__ + "static/image/logo-family/logo_gift@2x.png?18f65eb1";